import { ExpressionRuleEditorBase } from "../Expressions/ExpressionRuleEditorBase";
import { ExpressionRule } from "../../rule-engine-core/Expressions/ExpressionRule";
import { AppGlueError } from "../../rule-engine-core/AppGlueError";
import { ReactNode } from "react";

export class ExpressionRuleEditorRegistrationData {
    typeName: string;
    editorPrototype: ExpressionRuleEditorBase;
    icon: JSX.Element;

    constructor(editorPrototype: ExpressionRuleEditorBase, typeName: string, icon: JSX.Element) {
        this.typeName = typeName;
        this.editorPrototype = editorPrototype;
        this.icon = icon;
    }

    create(rule: ExpressionRule): ExpressionRuleEditorBase {
        let prototype = Object.getPrototypeOf(this.editorPrototype);

        let editor = new prototype.constructor();

        // console.log(rule.__type, editor)

        Reflect.set(editor, "ruleData", rule);

        return editor;
    }
}

export class ExpressionRuleEditorRegistration {
    static registrations: { [key: string]: ExpressionRuleEditorRegistrationData } = {};

    static registerExpressionEditor(
        example: ExpressionRuleEditorBase,
        expressionRule: ExpressionRule,
        icon: JSX.Element,
    ) {
        ExpressionRuleEditorRegistration.registrations[expressionRule.__type] =
            new ExpressionRuleEditorRegistrationData(example, expressionRule.__type, icon);
    }

    static getExpressionByTypeName(typeName: string): ExpressionRuleEditorRegistrationData | undefined {
        return ExpressionRuleEditorRegistration.registrations[typeName];
    }
}

export function RegisterExpressionRuleEditor(
    exampleExpression: ExpressionRuleEditorBase,
    forExpressionRule: ExpressionRule,
    icon: JSX.Element,
) {
    ExpressionRuleEditorRegistration.registerExpressionEditor(exampleExpression, forExpressionRule, icon);

    if (!ExpressionRuleEditorRegistration.getExpressionByTypeName(forExpressionRule.__type))
        throw new Error("registration failed");
}

export function RenderExpressionRule(rule: ExpressionRule | undefined): JSX.Element | ReactNode | null {
    if (!rule) return null;

    let editor: ExpressionRuleEditorBase | undefined = Reflect.get(rule, "___editor") as ExpressionRuleEditorBase;

    if (!editor) {
        editor = ExpressionRuleEditorRegistration.getExpressionByTypeName(rule.__type)?.create(rule);
        Reflect.set(rule, "___editor", editor);
    }

    if (!editor) throw new AppGlueError("no editor found for " + rule.__type);

    return editor.render();
}

export function GetExpressionRuleIcon(type: string): JSX.Element {
    let reg = ExpressionRuleEditorRegistration.getExpressionByTypeName(type);

    if (!reg) throw new AppGlueError("could not find registration " + type);

    return reg.icon;
}
